import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sendResetMailForCurrentUser, logoutUser } from "../web/src/services/authService";

export default function ForceResetPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email || "";
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function handleSendResetMail() {
    setLoading(true);
    setError("");
    setMessage("");

    try {
      await sendResetMailForCurrentUser();
      setMessage("Şifre yenileme linki mail adresinize gönderildi.");
    } catch(err) {
      console.error("FORGOT PASSWORD ERROR:", err);
      setError(err?.code || err?.message || "Şifre yenileme maili gönderilemedi.");
    } finally {
      setLoading(false);
    }
  }

  async function handleBackToLogin() {
    await logoutUser();
    navigate("/");
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Şifre Yenileme Zorunlu</h2>
        <p>İlk giriş yaptığınız için geçici şifre ile devam edemezsiniz.</p>
        <p>
          Şifre yenileme linki şu adrese gönderilecek:
          <br />
          <strong>{email || "Email bulunamadı"}</strong>
        </p>

        <button style={styles.button} onClick={handleSendResetMail} disabled={loading}>
          {loading ? "Gönderiliyor..." : "Reset Maili Gönder"}
        </button>

        <button style={styles.secondaryButton} onClick={handleBackToLogin}>
          Çıkış Yap
        </button>

        {message && <p style={styles.success}>{message}</p>}
        {error && <p style={styles.error}>{error}</p>}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f7f7f7"
  },
  card: {
    width: 460,
    background: "#fff",
    padding: 24,
    borderRadius: 12,
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
  },
  button: {
    width: "100%",
    padding: 12,
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
    marginTop: 12
  },
  secondaryButton: {
    width: "100%",
    padding: 12,
    borderRadius: 8,
    border: "1px solid #ccc",
    background: "#fff",
    cursor: "pointer",
    marginTop: 10
  },
  success: {
    color: "green",
    marginTop: 12
  },
  error: {
    color: "crimson",
    marginTop: 12
  }
};